import React from 'react';

function M4content() {
    return (
        <div id="mcontent4" className="row">
            <div className="container">
                <div className="row">
                <div id="bodycards" className="container">
                    <div className="row">
                    <div className="card-deck">
                        <div id="mcontent4b" className="card">
                        <div className="card-body">
                            <img className="img-fluid" src="images/cartoonplumber.jpg" alt="Cartoon Plumber" />
                        </div>
                        </div>
                        <div id="mcontent4b" className="card">
                        <div className="card-body">
                            <h5 className="card-title font-weight-bold">What Sets Us Apart From Other Plumbers?</h5>
                            <p>Since 1981, we have been providing our customers with the high level of quality service they deserve.</p>
                            <p>What you will discover when you work with us is personalized service that is tailored to your specific situation. We do not carry out patch jobs or one-size-fits-all solutions. We take the time to inspect your system and provide an accurate diagnosis of the problem. This allows us to provide the best solution at the best value.</p>
                            <p>You can expect options that are guaranteed to fit your specific problem and match your budget. Our recommendations come with your best interests in mind.</p>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>


    );
}

export default M4content;